import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useMutation } from '@apollo/react-hooks';
import { RefreshLeadgenForm, RefreshLeadgenFormVariables } from './__generated__/RefreshLeadgenForm';

const REFRESH_LEAD_FORM_MUTATION = gql`
  mutation RefreshLeadgenForm($externalIds: [ID!]!) {
    refreshLeadgenForm(externalIds: $externalIds) {
      facebookLeadgenForms {
        id
        leadsCount
      }
      errors
    }
  }
`;

export const useRefreshLeadgenFromMutation = () => {
  return useMutation<RefreshLeadgenForm, RefreshLeadgenFormVariables>(REFRESH_LEAD_FORM_MUTATION, {
    client: kmsClient
  });
};
